/**
 * ==========================================================================
 * META PIXEL E-COMMERCE EVENTS — getpetpure.co.uk (Dawn Theme)
 * Pixel ID : 1452209434636708
 *
 * Loads deferred AFTER pubsub.js + constants.js so Dawn's
 * subscribe() / PUB_SUB_EVENTS are guaranteed to be available.
 *
 * Events handled here:
 *   AddToCart       – product-form, quick-add, quick-add-bulk
 *   InitiateCheckout– cart-notification form, cart page form,
 *                     any button[name=checkout], a[href*=checkout]
 *
 * ViewContent is inlined directly in main-product.liquid (see below).
 * PageView  is inlined in layout/theme.liquid base code (already fires).
 * Purchase  must be set in Settings > Checkout > Additional scripts.
 * ==========================================================================
 */

(function () {
  'use strict';

  /* -----------------------------------------------------------------------
   * 1. HELPERS
   * -------------------------------------------------------------------- */

  var PIXEL_ID = '1452209434636708';

  function safeFbq() {
    if (typeof window.fbq === 'function') {
      window.fbq.apply(window, arguments);
    }
  }

  /** Prices from Shopify are always integers in the store's minor unit (pence / cents). */
  function toDec(minorUnit) {
    return parseFloat((parseInt(minorUnit, 10) / 100).toFixed(2));
  }

  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return (window.__ppCurrency || 'GBP');
  }

  /* -----------------------------------------------------------------------
   * 2. DEDUPLICATION — prevents double‑firing when both the fetch
   *    interceptor AND the PubSub subscriber pick up the same add-to-cart.
   * -------------------------------------------------------------------- */

  var _lastAtcKey  = '';
  var _lastAtcTime = 0;
  var _lastIcTime  = 0;

  function canFireAtc(key) {
    var now = Date.now();
    if (_lastAtcKey === key && now - _lastAtcTime < 1200) return false;
    _lastAtcKey  = key;
    _lastAtcTime = now;
    return true;
  }

  function canFireIc() {
    var now = Date.now();
    if (now - _lastIcTime < 2500) return false;
    _lastIcTime = now;
    return true;
  }

  /* -----------------------------------------------------------------------
   * 3. AddToCart — build payload from a /cart/add.js response
   *    The response is EITHER:
   *      a) a single item object  { id, variant_id, quantity, price, … }
   *      b) a multi-item object   { items: [ … ] }   (bulk quick-add)
   * -------------------------------------------------------------------- */

  function buildAtcPayload(data) {
    if (!data) return null;

    var contentIds = [];
    var contents   = [];
    var totalValue = 0;
    var firstName  = '';

    var items = (data.items && Array.isArray(data.items)) ? data.items : [data];

    for (var i = 0; i < items.length; i++) {
      var item  = items[i];
      var vid   = String(item.id || item.variant_id || '');
      var qty   = parseInt(item.quantity, 10)  || 1;
      var price = toDec((item.final_price != null) ? item.final_price : (item.price || 0));

      if (!vid) continue;
      contentIds.push(vid);
      contents.push({ id: vid, quantity: qty, item_price: price });
      totalValue += price * qty;
      if (!firstName) firstName = item.product_title || item.title || '';
    }

    if (!contentIds.length) return null;

    return {
      content_ids  : contentIds,
      content_name : firstName,
      content_type : 'product',
      value        : parseFloat(totalValue.toFixed(2)),
      currency     : getCurrency(),
      contents     : contents
    };
  }

  function fireAddToCart(data) {
    var payload = buildAtcPayload(data);
    if (!payload) return;

    var dedupKey = payload.content_ids.slice().sort().join(',') + ':' + payload.value;
    if (!canFireAtc(dedupKey)) return;

    safeFbq('track', 'AddToCart', payload);
  }

  /* -----------------------------------------------------------------------
   * 4. AddToCart — source A: Dawn PubSub (most reliable, fires after
   *    the cart response is confirmed successful by product-form.js)
   * -------------------------------------------------------------------- */

  // PUB_SUB_EVENTS and subscribe() are guaranteed available because this
  // file loads with defer AFTER pubsub.js and constants.js.
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event) return;

    var source   = event.source || '';
    var cartData = event.cartData || null;

    if (!cartData) return;

    if (source === 'product-form' || source === 'quick-add') {
      // cartData is the raw /cart/add.js response: single item or {items:[…]}
      fireAddToCart(cartData);

    } else if (source === 'quick-add-bulk') {
      // cartData is the full cart object from /cart/update.js — we don't
      // have a clean "newly added" diff here, so skip to avoid wrong payload.
    }
    // 'cart-items' source = quantity change, not an add; skip.
  });

  /* -----------------------------------------------------------------------
   * 5. AddToCart — source B: fetch() interceptor (catches quick-add-bulk,
   *    any 3rd-party cart add, and acts as a safety net for product-form)
   * -------------------------------------------------------------------- */

  if (typeof window.fetch === 'function') {
    var _nativeFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var reqUrl = '';
      if (typeof args[0] === 'string') {
        reqUrl = args[0];
      } else if (args[0] && typeof args[0].url === 'string') {
        reqUrl = args[0].url;
      }

      var promise = _nativeFetch.apply(this, args);

      if (reqUrl.indexOf('/cart/add') !== -1) {
        promise.then(function (response) {
          if (response && response.ok) {
            response.clone().json().then(function (data) {
              fireAddToCart(data);
            }).catch(function () {});
          }
          return response;
        }).catch(function () {});
      }

      return promise;
    };
  }

  /* -----------------------------------------------------------------------
   * 6. InitiateCheckout — fire whenever user clicks any checkout trigger.
   *
   *    Targets (cart_type = "notification"):
   *      • #cart-notification-form [name=checkout] button
   *      • any button[name=checkout] (cart page, drawer if ever enabled)
   *      • a[href*=checkout]
   *      • .shopify-payment-button__button  (dynamic checkout / BIN)
   * -------------------------------------------------------------------- */

  function buildIcPayload() {
    var cart = window.__ppCart || {};
    var items = Array.isArray(cart.items) ? cart.items : [];

    var contentIds = [];
    var contents   = [];
    var totalValue = 0;

    for (var i = 0; i < items.length; i++) {
      var itm   = items[i];
      var vid   = String(itm.id || itm.variant_id || '');
      var qty   = parseInt(itm.quantity, 10) || 1;
      var price = toDec((itm.final_price != null) ? itm.final_price : (itm.price || 0));

      if (vid) {
        contentIds.push(vid);
        contents.push({ id: vid, quantity: qty, item_price: price });
      }
      totalValue += price * qty;
    }

    // Fallback: if cart not yet synced, use the page-level product variant
    // stored by ViewContent (from main-product.liquid inline script).
    if (!contentIds.length && window.__ppCurrentVariant) {
      var cv = window.__ppCurrentVariant;
      contentIds = [String(cv.id)];
      contents   = [{ id: String(cv.id), quantity: 1, item_price: cv.price }];
      totalValue = cv.price;
    }

    return {
      content_type : 'product',
      content_ids  : contentIds,
      contents     : contents,
      value        : parseFloat(totalValue.toFixed(2)),
      currency     : getCurrency(),
      num_items    : cart.item_count || contentIds.length
    };
  }

  function fireInitiateCheckout() {
    if (!canFireIc()) return;
    safeFbq('track', 'InitiateCheckout', buildIcPayload());
  }

  // Capture phase so we fire before the browser navigates away.
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el) return;

    var node = el.closest(
      'button[name="checkout"], input[name="checkout"], ' +
      'a[href*="checkout"], ' +
      '.shopify-payment-button__button, ' +
      '#CartDrawer-Checkout, #checkout'
    );
    if (node) fireInitiateCheckout();
  }, true);

  // Also catch form submits (handles enter-key checkout on cart page).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('checkout') !== -1) {
      fireInitiateCheckout();
      return;
    }
    // Cart form submitted via a checkout-named button
    var sub = e.submitter;
    if (sub && sub.getAttribute('name') === 'checkout') {
      fireInitiateCheckout();
    }
  }, true);

  /* -----------------------------------------------------------------------
   * 7. Keep __ppCart in sync so InitiateCheckout always has fresh data.
   *    We poll /cart.js once after every cartUpdate event.
   * -------------------------------------------------------------------- */

  var _cartSyncTimer = null;
  function scheduleCartSync() {
    clearTimeout(_cartSyncTimer);
    _cartSyncTimer = setTimeout(function () {
      var url = (window.routes && window.routes.cart_url)
        ? window.routes.cart_url + '.js'
        : '/cart.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) window.__ppCart = cart; })
        .catch(function () {});
    }, 400);
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartSync);

  // Prime the cart cache immediately on page load.
  scheduleCartSync();

})();
